<template>
  <div>
    <Breadcrumbs main="Турниры" title="Шаблоны турниров"/>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5>Шаблоны турниров</h5>
              <b-btn variant="primary" @click="$router.push({ name: 'template_create' })">
                <i class="fa fa-plus mr-1"></i> Создать шаблон
              </b-btn>
            </div>
            <div class="card-body">
              <div v-if="isLoading" class="text-center py-5">
                <b-spinner variant="primary"></b-spinner>
              </div>
              <b-table
                  v-else
                  responsive
                  show-empty
                  striped
                  bordered
                  :fields="fields"
                  :items="templates"
                  class="mb-3"
              >
                <template #cell(created_at)="data">
                  {{ formatDate(data.item.created_at) }}
                </template>
                <template #cell(actions)="data">
                  <div class="d-flex justify-content-center">
                    <b-btn variant="primary" size="sm" class="mr-1" @click="editTemplate(data.item.id)">
                      <i class="fa fa-edit"></i>
                    </b-btn>
                    <b-btn variant="danger" size="sm" @click="confirmDelete(data.item)">
                      <i class="fa fa-trash"></i>
                    </b-btn>
                  </div>
                </template>
                <template #empty>
                  <div class="text-center text-muted py-3">Шаблонов пока нет</div>
                </template>
              </b-table>
              <b-pagination
                  v-if="totalPages > 1"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  @change="loadTemplates"
                  class="my-0"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "TemplatesList",
  data() {
    return {
      templates: [],
      isLoading: false,
      currentPage: 1,
      totalRows: 0,
      totalPages: 1,
      perPage: 15,
      fields: [
        { key: 'id', label: '№', sortable: true },
        { key: 'name', label: 'Название' },
        { key: 'created_at', label: 'Дата создания', sortable: true },
        { key: 'actions', label: 'Действия' },
      ],
    }
  },
  created() {
    this.loadTemplates()
  },
  methods: {
    async loadTemplates(page) {
      this.isLoading = true
      try {
        const res = await api.tournamentTemplate.index({ page: page || this.currentPage })
        // Поддержка обоих форматов: { data: [...], meta } и просто [...]
        this.templates = Array.isArray(res.data?.data) ? res.data.data
            : Array.isArray(res.data) ? res.data
            : []
        const meta = res.data?.meta
        if (meta) {
          this.totalRows = meta.total
          this.totalPages = meta.last_page
          this.perPage = meta.per_page
          this.currentPage = meta.current_page
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.isLoading = false
      }
    },
    editTemplate(id) {
      this.$router.push({ name: 'template_edit', params: { id } })
    },
    confirmDelete(template) {
      this.$bvModal.msgBoxConfirm(`Удалить шаблон "${template.name}"?`, {
        title: 'Подтверждение',
        okVariant: 'danger',
        okTitle: 'Удалить',
        cancelTitle: 'Отмена',
      }).then(confirmed => {
        if (confirmed) this.deleteTemplate(template.id)
      })
    },
    async deleteTemplate(id) {
      try {
        await api.tournamentTemplate.delete(id)
        this.showToast('Шаблон удалён')
        this.loadTemplates()
      } catch (e) {
        this.showToast('Не удалось удалить шаблон', 'error')
      }
    },
    showToast(message, type = 'success') {
      const t = this.$toasted[type](message, {
        action: {
          text: '✕',
          onClick: (e, toastObject) => { toastObject.goAway(0) }
        }
      })
      setTimeout(() => { if (t) t.goAway(0) }, 3000)
    },
    formatDate(dateStr) {
      if (!dateStr) return '—'
      return new Date(dateStr).toLocaleDateString('ru-RU', {
        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
      })
    },
  },
}
</script>
